import { Card, CardHeader, CardContent, CardActions, SxProps } from '@mui/material';

/**
 * SectionCard Component
 * Standard container for content sections with optional header and actions
 */

interface SectionCardProps {
  title?: string;
  subtitle?: string;
  avatar?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  elevation?: number;
  sx?: SxProps;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  subtitle,
  avatar,
  actions,
  children,
  elevation = 2,
  sx
}) => {
  return (
    <Card elevation={elevation} sx={sx}>
      {(title || subtitle || avatar) && (
        <CardHeader
          avatar={avatar}
          title={title}
          subheader={subtitle}
        />
      )}
      <CardContent>
        {children}
      </CardContent>
      {actions && (
        <CardActions>
          {actions}
        </CardActions>
      )}
    </Card>
  );
};
